/* eslint-disable max-len */
import React from 'react';

const FullScreenIcon = () => (
  <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path d="M0,0 L13,0 L13,13 L0,13 L0,0 Z" id="path-1" />
      <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="13" fill="white">
        <use xlinkHref="#path-1" />
      </mask>
      <path d="M0,0 L13,0 L13,13 L0,13 L0,0 Z" id="path-3" />
      <mask id="mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="13" fill="white">
        <use xlinkHref="#path-3" />
      </mask>
      <path d="M0,0 L13,0 L13,13 L0,13 L0,0 Z" id="path-5" />
      <mask id="mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="13" fill="white">
        <use xlinkHref="#path-5" />
      </mask>
      <path d="M0,0 L13,0 L13,13 L0,13 L0,0 Z" id="path-7" />
      <mask id="mask-8" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="13" fill="white">
        <use xlinkHref="#path-7" />
      </mask>
    </defs>
    <g id="Atoms-/-Icons-/-Full-Screen" stroke="none" fill="none" fillRule="evenodd" strokeDasharray="5,42">
      <g id="Group" fillRule="nonzero" stroke="#FFFFFF" strokeWidth="3">
        <use id="Rectangle" mask="url(#mask-2)" xlinkHref="#path-1" />
        <use id="Rectangle" mask="url(#mask-4)" transform="translate(6.500000, 6.500000) scale(-1, 1) translate(-6.500000, -6.500000) " xlinkHref="#path-3" />
        <use id="Rectangle" mask="url(#mask-6)" transform="translate(6.500000, 6.500000) scale(-1, -1) translate(-6.500000, -6.500000) " xlinkHref="#path-5" />
        <use id="Rectangle" mask="url(#mask-8)" transform="translate(6.500000, 6.500000) scale(1, -1) translate(-6.500000, -6.500000) " xlinkHref="#path-7" />
      </g>
    </g>
  </svg>
);

FullScreenIcon.propTypes = {};

export default FullScreenIcon;